import { Avatar, Button, Card, CardBody } from "@heroui/react";
import React from "react";

import { useAuth } from "@wc/domain/authn";
import { formatDate } from "@wc/domain/dates";
import EditableInput from "@wc/ui/components/editable-input";

/**
 * Displays user profile information with editable fields
 * @param {object} props The component props
 * @param {() => void} props.onDeleteClick Callback when delete button is clicked
 * @returns {React.ReactElement} The component
 */
export default function UserProfileInfo({ onDeleteClick }) {
  const auth = useAuth();
  const user = auth.getCurrentUser();
  console.log(user);

  return (
    <Card className="p-3">
      <CardBody>
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <Avatar
              src={user.photoURL}
              name={user.displayName}
              size="lg"
              className="shrink-0"
            />
            <div className="flex flex-col">
              <span className="text-lg font-semibold">{user.displayName}</span>
              <span className="text-default-500 text-sm">{user.email}</span>
            </div>
          </div>

          <ul className="flex flex-col gap-4">
            <li className="flex items-center gap-4">
              <b className="min-w-24">Name:</b>
              <EditableInput
                value={user.displayName}
                onSave={async (newName) =>
                  await auth.updateDisplayName(newName)
                }
              />
            </li>
            <li className="flex gap-4">
              <b className="min-w-24">Email:</b>
              <span className="text-default-500">{user.email}</span>
            </li>
            <li className="flex gap-4">
              <b className="min-w-24">Last Login:</b>
              <span>{formatDate(user.lastLogin.seconds * 1000)}</span>
            </li>
          </ul>

          <div className="border-divider mt-4 border-t pt-4">
            <Button color="danger" variant="flat" onPress={onDeleteClick}>
              Delete Account
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
